import React from 'react';
import MasterCrud from './MasterCrud';

export default function Trucks() {
  return (
    <MasterCrud
      title="Trucks"
      endpoint="/api/master/trucks"
      // A truck number is unique per COMPANY, so the fleet is only readable filtered by company —
      // and it grows fast (every sub-contractor's truck on a scanned ticket lands here).
      filters={[{ key: 'companyId', label: 'Company' }]}
      searchKeys={['number', 'plate', 'driverName', 'truckType']}
      columns={[
        { key: 'number', label: 'Truck #' },
        { key: 'plate', label: 'Plate' },
        { key: 'truckType', label: 'Type' },
        { key: 'driverName', label: 'Driver' },
        { key: 'companyId', label: 'Company', lookup: 'companyId' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'number', label: 'Truck Number', required: true },
        { key: 'plate', label: 'License Plate' },
        {
          key: 'truckType',
          label: 'Truck Type',
          type: 'select',
          helperText: 'Drives pricing (belly/end/flat). Confirm with Jimmy for flatbed.',
          options: [
            { value: 'BELLY', label: 'Belly Dump' },
            { value: 'END', label: 'End Dump' },
            { value: 'FLAT', label: 'Flatbed' },
          ],
        },
        {
          key: 'driverName',
          label: 'Driver',
          type: 'select',
          optionsEndpoint: '/api/master/drivers',
          optionValue: 'name',
          optionLabel: 'name',
        },
        {
          key: 'driverEffectiveDate',
          label: 'Driver Effective Date',
          type: 'date',
          helperText: 'When this driver starts on the truck (back-date to a week start to pay that week). Defaults to today.',
        },
        {
          key: 'companyId',
          label: 'Company',
          type: 'select',
          required: true,
          optionsEndpoint: '/api/master/companies',
          optionValue: 'id',
          optionLabel: 'name',
        },
      ]}
    />
  );
}
